<template>
    <div class="container">
        <br /><br />
        <div v-if="isAccessable" class="jumbotron">
            <h1 class="display-4">
                <span v-if="isEmailAuthorized">Congratulations!</span>
                <span v-else>Welcome!</span>
            </h1>
            <p v-if="isEmailAuthorized" class="lead">We confirmed your access to <strong>{{resourceName}}</strong> owned by <strong>{{organizationName}}</strong> data in TransparentChoice application</p>
            <p v-else class="lead">You are about to access <strong>{{resourceName}}</strong> owned by <strong>{{organizationName}}</strong> data in TransparentChoice application</p>
            <hr>

            <div v-if="isEmailAuthorized">
                <div v-if="!isAuthenticatedUser" class="row">
                    <div class="col-6">
                        <a :href="accessUrl" class="btn btn-lg btn-success">Go to {{resourceName}}</a>
                    </div>
                    <div class="col-6">
                        <!--<div>
                            <h5>Skip email confirmation in the future and ...</h5>
                            <ul>
                                <li>forgot about links</li>
                                <li>access your dashboard</li>
                                <li>all data in one place</li>
                                <li>login with password</li>
                                <li>fast and secure</li>
                            </ul>
                            <a :href="`/#/organizations/users/requestaccount/${organizationUnitId}`" target="_blank">Request an account</a>
                        </div>-->
                    </div>
                </div>
                <div v-else class="row">
                    <div class="col-12">
                        <a :href="accessUrl" class="btn btn-lg btn-success" style="margin: 20px;">Go to {{resourceName}}</a>
                    </div>
                </div>
            </div>

            <div v-else>
                <div v-if="!succeedSendEmailConfirmationCommandV1">
                    <p>We have to confirm your email for security reasons before you will be able to access it</p>

                    <div class="input-group mb-3">
                        <input v-model="email" type="email" class="form-control form-control-lg" placeholder="Your email">
                        <div class="input-group-append">
                            <button @click="invokeSendEmailConfirmationCommandV1" class="btn btn-primary" type="button">Confirm</button>
                        </div>
                    </div>
                    <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                    <hr />
                    <br />

                    <div style="text-align: center;">
                        <h5>or</h5>
                        <a :href="`/#/signin?returnUrl=${encodeURIComponent(accessUrl)}`" class="btn btn-secondary">
                            Sign in with TransparentChoice account
                        </a>
                    </div>
                </div>
                <div v-else>
                    <p>We send confirmation email on your maiblox. Please follow the link from that email to continue...</p>
                </div>
            </div>
        </div>

        <div v-else class="jumbotron">
            <h1 class="display-4">Access denied</h1>
            <p>{{accessIssueDetails}}</p>
            <hr>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { ref, computed, watch, onMounted } from 'vue'
    import { useRoute } from '@common/composables'
    import { useAccessSharePage } from '@DataSharing/Shares/pages-core'
    import '@common/Components/ValidationError.vue'

    document.title = 'Access TransparentChoice'

    const id = useRoute().params.id
    const email = ref()

    const { useAccessShareQuery, useSendEmailConfirmationCommand } = useAccessSharePage()
    
    const { modelAccessShareQueryV1, runAccessShareQueryV1 } = useAccessShareQuery(id)
    const { invokeSendEmailConfirmationCommandV1, succeedSendEmailConfirmationCommandV1, validationErrors } = useSendEmailConfirmationCommand(id, email)

    const isEmailAuthorized = computed(() => modelAccessShareQueryV1.value?.IsEmailAuthorized)
    const isAuthenticatedUser = computed(() => modelAccessShareQueryV1.value?.IsAuthenticatedUser)
    const organizationName = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitName)
    const organizationUnitId = computed(() => modelAccessShareQueryV1.value?.OrganizationUnitId)
    const workspaceName = computed(() => modelAccessShareQueryV1.value?.WorkspaceName)
    const projectName = computed(() => modelAccessShareQueryV1.value?.ProjectName)
    const resourceName = computed(() => modelAccessShareQueryV1.value?.ResourceName)
    const isAccessable = computed(() => modelAccessShareQueryV1.value?.IsAccessable)
    const accessUrl = computed(() => modelAccessShareQueryV1.value?.AccessUrl)
    const accessIssueDetails = computed(() => modelAccessShareQueryV1.value?.AccessIssueDetails)

    runAccessShareQueryV1()
</script>
